<template>
  <div class="cs-container">
    <div class="w-full h-full md:flex">
      <div class="m-auto">
        <div class="w-32 bg-white"></div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
